export function InputContainer({ children }: { children: React.ReactNode }) {
    return (
        <div className="grid grid-cols-2 gap-x-2 justify-between my-2">
            { children }
        </div>

    );
}